import type { SviTheme } from "../types/equity";
import type { FuelState } from "../types/vlm";
import type { BriefTemplate } from "../types/brief";

export const THEME_LABELS: Record<SviTheme, string> = {
  RPL_THEME1: "Socioeconomic Status",
  RPL_THEME2: "Household Characteristics",
  RPL_THEME3: "Racial/Ethnic Minority Status",
  RPL_THEME4: "Housing & Transportation",
};

export const FUEL_STATE_LABELS: Record<FuelState, string> = {
  actively_burning: "🔥 Actively Burning",
  dry_cured:        "🌾 Dry / Cured",
  moderate_moisture: "🍂 Moderate Moisture",
  green_lush:       "🌿 Green / Lush",
  snow_covered:     "❄️ Snow Covered",
  unknown:          "Unknown",
};

export const TEMPLATE_LABELS: Record<BriefTemplate, string> = {
  standard:              "Standard",
  structure_protection:  "Structure Protection",
  reburn_warning:        "Re-burn Warning",
  equity_blind:          "Equity Data Unavailable",
  imagery_blind:         "Imagery Unavailable",
  fully_blind:           "Both Unavailable",
  agent_unavailable:     "Agent Failure",
};

export const CA_CENTER: [number, number] = [37.5, -119.5];
export const CA_ZOOM = 6;
